<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="targetTitle" width="750px">
    <div slot="content">
      <el-form :model="formData" ref="formData" :rules="rules">
        <el-row type="flex">
          <el-col :span="11">
            <el-form-item label="IP주소" prop="scanStart">
              <el-input ref="scanStartRef" placeholder="IP를 입력해주세요" @change="onChangeIpByValue" v-model="formData.scanStart"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
          </el-col>
          <el-col :span="11">
            <el-form-item label="서브넷마스크" prop="scanEnd">
              <el-select style="width: 100%;" @change="onChangeIpByValue" v-model="formData.scanEnd">
                <el-option v-for="item in subnetmaskList" :label="item.basicinfoSubname" :value="item.basicinfoSubid" :key="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-top: 10px;">
          <el-form-item label="관리구간"></el-form-item>
        </el-row>
        <el-row type="flex">
          <el-col :span="11">
            <el-form-item prop="dhcpRange1Start">
              <el-input disabled v-model="formData.dhcpRange1Start"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="display: flex; justify-content: center;">
            <el-row type="flex" justify="center" align="middle">
              <span style="16px;">~</span>
            </el-row>
          </el-col>
          <el-col :span="11">
            <el-form-item prop="dhcpRange1End">
              <el-input disabled v-model="formData.dhcpRange1End"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-top: 10px;">
          <el-form-item prop="purpose" label="용도">
            <el-input placeholder="용도를 입력해주세요" v-model="formData.purpose"></el-input>
          </el-form-item>
        </el-row>
        <el-row style="padding-top: 10px;">
          <el-form-item prop="addressType" label="구분">
            <el-select style="width: 100%;" v-model="formData.addressType">
              <el-option label="공인" value="PUBLIC"></el-option>
              <el-option label="사설" value="PRIVATE"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid"  @click="onSaveIpBandwidth">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { isUndefined, cloneDeep } from 'lodash';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import msgUtil from '@/utils/message';
import NetdeviceIpManagement from '@/api/settings/netdevice/netdevice-ip-management';

export default {
  name: 'WIpBandwidthSlidingPopup',
  data() {
    return {
      formData: {
        scanStart: '',
        scanEnd: 1,
        addressType: 'PUBLIC',
        dhcpRange1Start: '',
        dhcpRange1End: '',
        purpose: '',
      },
      popupMode: 'add',
      subnetmaskList: [],
      targetTitle: '',
      rules: {
        scanStart: { required: true, trigger: 'blur', validator: this.validatePassForIp },
      },
    };
  },
  mounted() {
    // subnetmask List api
    NetdeviceIpManagement.getSubnetmaskList().then((response) => {
      this.subnetmaskList = response.data.data;
    });
  },
  methods: {
    open(item) {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.$refs.formData.resetFields();
        if (item) {
          this.popupMode = 'update';
          this.formData = cloneDeep(item);
          this.formDataOrigin = cloneDeep(this.formData);
          this.targetTitle = 'IP대역 정보';
          // api
          this.onChangeIpByValue();
        } else {
          this.popupMode = 'add';
          this.targetTitle = 'IP대역 추가';
        }
      });
    },
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    onSaveIpBandwidth() {
      this.$refs.formData.validate().then((valiResponse) => {
        if (valiResponse) {
          const target = 'IP대역';
          if (this.popupMode === 'add') {
            // IP대역 추가 api
            const action = msgUtil.action.ADD;
            NetdeviceIpManagement.insertNcmIpBandList(this.formData).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('load-data');
                this.clickCloseBtn();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          } else {
            // IP대역 정보 수정 api
            const action = msgUtil.action.SAVE;
            NetdeviceIpManagement.updateNcmIpBandList(this.formData).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('load-data');
                this.clickCloseBtn();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          }
        }
      }).catch(() => {});
    },
    // IP 주소, 서브넷 마스크 변경 시 IP관리구간을 다시 계산하기위해 조회한다.
    onChangeIpByValue() {
      this.$nextTick(() => {
        this.$refs.formData.validate().then((valiResponse) => {
          if (valiResponse) {
            const params = {
              scanStart: this.formData.scanStart,
              scanEnd: this.formData.scanEnd,
            };
            // 서브넷 마스트에 따른 Ip 대역폭 조회 api
            NetdeviceIpManagement.getDHCPList(params).then((response) => {
              this.formData.dhcpRange1Start = response.data.data.dhcpRange1Start;
              this.formData.dhcpRange1End = response.data.data.dhcpRange1End;
            });
          }
        }).catch(() => {});
      });
    },
    validatePassForIp(rule, value, callback) {
      if (isUndefined(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (validateIpv4(value) || validateIpv6(value)) {
        callback();
      } else {
        callback(new Error('올바른 IPv4 주소형식을 입력해주세요'));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/IpManagementSettings/IpBandwidthSetting/popup/IpBandwidthSlidingPopup.vue